__turbopack_context__.v({
  "dragHandle": "sortableMediaGrid-module-scss-module__ExQvUq__dragHandle",
  "mediaCard": "sortableMediaGrid-module-scss-module__ExQvUq__mediaCard",
  "mediaCardDraggable": "sortableMediaGrid-module-scss-module__ExQvUq__mediaCardDraggable",
  "mediaCardOverlay": "sortableMediaGrid-module-scss-module__ExQvUq__mediaCardOverlay",
  "mediaGrid": "sortableMediaGrid-module-scss-module__ExQvUq__mediaGrid",
  "mediaImage": "sortableMediaGrid-module-scss-module__ExQvUq__mediaImage",
  "mediaPdf": "sortableMediaGrid-module-scss-module__ExQvUq__mediaPdf",
  "mediaPreview": "sortableMediaGrid-module-scss-module__ExQvUq__mediaPreview",
  "mediaVideo": "sortableMediaGrid-module-scss-module__ExQvUq__mediaVideo",
  "removeButton": "sortableMediaGrid-module-scss-module__ExQvUq__removeButton",
});
